const ADD_GOODS_COUNT = "addGoodsCount"
const ADD_NEW_GOODS = "addNewGoods"
export { ADD_GOODS_COUNT, ADD_NEW_GOODS }